import React, {
    useState,
} from "react"

import {
    Button,
    Col,
    Row,
} from "react-bootstrap"

import EMETLDateSelection from "../../EMETLDateSelection"
import "./style.css"

export type EMETLDateRangeHeaderProps = {
    onDatesSubmit: (startDate: string, endDate: string) => void,
    initialStartDate?: string,
    initialEndDate?: string,
    submitMessage?: string,
}

const EMETLDateRangeHeader = (props: EMETLDateRangeHeaderProps) => {
    const {
        onDatesSubmit,
        initialStartDate,
        initialEndDate,
        submitMessage = "Filter"
    } = props
    const [startDate, setStartDate] = useState(initialStartDate || "")
    const [endDate, setEndDate] = useState(initialEndDate || "")

    const handleSubmit = () => {
        onDatesSubmit(startDate, endDate)
    }

    return (
        <Col className="dateRangeHeader">
            <div className="dateRangeHeaderContent">
                <Row>
                    <EMETLDateSelection
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                    />
                </Row>
                <Row>
                    <Button 
                        variant="outline-light"
                        onClick={handleSubmit}
                    >
                        {submitMessage}
                    </Button>
                </Row>
            </div>
        </Col>
    )
}

export default EMETLDateRangeHeader